import React, { useEffect, memo } from 'react';
import { initializeAnalytics } from '../../utils/analytics';

/**
 * Wrapper component that adds Google Analytics to any page
 */
const AnalyticsWrapper = ({ children }) => {
    useEffect(() => {
        const cleanup = initializeAnalytics();
        return cleanup;
    }, []);

    return <>{children}</>;
};

export default memo(AnalyticsWrapper);
